"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackSentiment = void 0;
var FeedbackSentiment;
(function (FeedbackSentiment) {
    FeedbackSentiment["NEUTRAL"] = "NEUTRAL";
    FeedbackSentiment["POSITIVE"] = "POSITIVE";
    FeedbackSentiment["NEGATIVE"] = "NEGATIVE";
})(FeedbackSentiment || (exports.FeedbackSentiment = FeedbackSentiment = {}));
